// @flow
import Mousetrap from 'mousetrap';

type HotKeysMap = { [command: string]: (keyboardEvent: any) => void };

export const bindHotKeysToDocument = (hotKeys: HotKeysMap) => {
  const commandList = Object.keys(hotKeys);

  commandList.forEach(command => {
    Mousetrap.bind(command, keyboardEvent => {
      keyboardEvent.preventDefault();
      hotKeys[command](keyboardEvent);
    });
  });
};

export const unBindHotKeysFromDocument = (hotKeys: HotKeysMap) => {
  const commandList = Object.keys(hotKeys);
  Mousetrap.unbind(commandList);
};
